import { css, CSSObject } from "@emotion/react";
import {
  constants,
  typographyStyles,
  visuallyHiddenStyles,
} from "@newsela/angelou";

const colors = constants.colors;
const coreBlue = { 600: colors.ui.core[600], 500: colors.ui.core[500] };
const black = colors.ui.black[500];
const { heading4Obj } = typographyStyles;

const CENTRAL_SECTION_WIDTH = 134;
const TEXT_AREA_CONTAINER_PADDING = 41;

css(visuallyHiddenStyles);

// --- Container ---
export const compareContrastContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  backgroundColor: "#fff",
  padding: "16px",
  boxSizing: "border-box",
};

// --- Both section ---
export const bothSectionContainerCss = css({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  margin: "0.1em 0",
});

export const bottomLineInputWrapperCss = css({
  border: "0",
  borderBottom: `5px solid ${coreBlue[600]}`,
  width: "17em",
  marginTop: "8px",
  paddingBottom: "4px",
});

export const bottomLineInputCss = css({
  fontWeight: "bold",
  textAlign: "center",
  width: "100%",
  color: black,
  ...heading4Obj,
});

export const paragraphCss = css({
  height: "auto",
  fontWeight: "bold",
  textAlign: "center",
  color: black,
  ...heading4Obj,
});

export const inputsRowCss = css({
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-end",
  gap: "1.2em",
});

export const bothLabelCss = css({
  marginTop: "0.3em",
  color: black,
  fontWeight: "bold",
  fontSize: "1.5em",
  whiteSpace: "nowrap",
  textAlign: "center",
});

export const vennDiagramTextAreaContainerCss: CSSObject = {
  position: "relative",
  display: "flex",
  justifyContent: "center",
  columnGap: "43px",
  minWidth: "100%",
  height: "360px",
  marginTop: "1em",
  padding: `70px ${TEXT_AREA_CONTAINER_PADDING}px 0`,

  "&:before, &:after": {
    content: '""',
    position: "absolute",
    top: 0,
    width: `calc(calc(100% / 2) + calc(${CENTRAL_SECTION_WIDTH}px / 2) + ${TEXT_AREA_CONTAINER_PADDING}px)`,
    height: "100%",
    border: `4px solid ${coreBlue[600]}`,
    backgroundColor: "transparent",
    borderRadius: "200px / 200px",
    pointerEvents: "none",
    boxSizing: "border-box",
  },

  "&:before": {
    left: 0,
  },

  "&:after": {
    right: 0,
  },
};

export const vennDiagramTextAreaWithCounterCss = (
  section: "left" | "right" | "center",
): CSSObject => {
  const sectionsSpecificStyles: CSSObject = {
    height: "219px",
  };

  if (section === "center") {
    sectionsSpecificStyles.minWidth = `${CENTRAL_SECTION_WIDTH}px`;
    sectionsSpecificStyles.maxWidth = `${CENTRAL_SECTION_WIDTH}px`;
  }

  return sectionsSpecificStyles;
};

export const vennDiagramTextAreaCss: CSSObject = {
  height: "100%",
};
